const TIPS = [
  {
    id: 'tuner',
    title: 'Tuner',
    text: "Did you know? With StrumIQ you've got a tuner in your pocket — great for tuning up on the go.",
    path: null,
  },
  {
    id: 'setups',
    title: 'Setups',
    text: 'Did you know? StrumIQ has a setup checklist, accessed from My Gear or Flip instruments. Track your setups as you go.',
    path: 'Instruments → My Gear / Flip → New Setup',
  },
  {
    id: 'watchlist',
    title: 'Watchlist',
    text: "Eyeing up gear online but not ready to buy? Add it to your Watchlist so it doesn't slip past you.",
    path: 'Quick add → Evaluate instrument → Save to Watchlist',
  },
  {
    id: 'flip',
    title: 'Flip',
    text: "Buying to resell? Mark it as a Flip so StrumIQ tracks your margin separately from your personal collection.",
    path: 'Instruments → Flip → +',
  },
  {
    id: 'rig',
    title: 'Rig / Pedalboard',
    text: "Your tone's not just the instrument — log your amps and pedals too. Your Rig tells the full story.",
    path: 'Instruments → Rig → +',
  },
  {
    id: 'ai_evaluation',
    title: 'AI Evaluation',
    text: "Not sure what a piece of gear is really worth? StrumIQ's AI evaluation gives you a confidence-scored estimate based on real market data.",
    path: null,
  },
  {
    id: 'streak',
    title: 'Weekly Streak',
    text: "Open the app and stay active — your streak is quietly building every week you show up.",
    path: null,
  },
  {
    id: 'metronome',
    title: 'Metronome',
    text: "Timing's everything. The built-in metronome's always one tap away in Tools.",
    path: null,
  },
  {
    id: 'region',
    title: 'Region-aware Pricing',
    text: "Wherever you're buying or selling — NZ, AU, US, UK — StrumIQ knows the right market to price against.",
    path: null,
  },
  {
    id: 'reminders',
    title: 'Reminders',
    text: "Got a setup coming up or strings to change? Reminders surface right here on your Home Screen so nothing gets missed.",
    path: null,
  },
];

export default TIPS;
